"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackScreenUsingSideNav = exports.trackBeforeUnload = void 0;

var _UsageTracker = _interopRequireDefault(require("./UsageTracker"));

var _Config = _interopRequireDefault(require("settings-ui-nav/api/Config"));

var findNavItemMatchingPath = function findNavItemMatchingPath(location, navItems) {
  var currentNavItem = navItems.find(function (navItem) {
    return navItem.matchesPath("" + location.basename + location.pathname);
  });

  if (currentNavItem.children.length) {
    return findNavItemMatchingPath(location, currentNavItem.children);
  }

  return currentNavItem;
};

var trackBeforeUnload = function trackBeforeUnload() {
  var eventKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var beforeUnloadTracker = _UsageTracker.default.clone({
    isBeforeUnload: true
  });

  beforeUnloadTracker.track(eventKey, eventProperties);
};

exports.trackBeforeUnload = trackBeforeUnload;

var trackScreenUsingSideNav = function trackScreenUsingSideNav(subscreen2) {
  return function (_ref) {
    var location = _ref.location;

    _Config.default.get().then(function (config) {
      var selectedNavItem = findNavItemMatchingPath(location, config);
      var screen = selectedNavItem.settingsGroup;
      var subscreen = selectedNavItem.trackingScreen;

      _UsageTracker.default.track('settingsNavPageView', {
        screen: screen,
        subscreen: subscreen,
        subscreen2: subscreen2 || ''
      });
    });
  };
};

exports.trackScreenUsingSideNav = trackScreenUsingSideNav;